<div *ngFor="let taxation of taxations" class="taxation">
    <div
        class="icon-container"
        [ngClass]="{ empty: taxation.property === null, positive: taxation.property, negative: !taxation.property }"
    >
        <mat-icon *ngIf="taxation.property !== null" [svgIcon]="taxation.property ? 'check' : 'close'"></mat-icon>
    </div>
    <span> {{ taxation.name | translate }} </span>
</div>
